// src/components/Home.js
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import '../App.css';

const HERO_IMAGES = [
  '/images/التصميم_الكهربائي___الحديث_4.png',
  '/images/تصميم_داخلي_لفيلا_1.jpg',
  '/images/تصميم_داخلي_لفيلا_2.png',
  '/images/تصميم_فيلا_سكنية_فاخرة_2.png',
  '/images/تصميم_فيلا_سكنية_فاخرة_3.png',
  '/images/تصميم_محطة_وقود_وخدمات_سيارات_متكاملة_1.jpg',
  '/images/تصميم_مسجد_بهوية_معاصرة_3_azUDVwH.jpg',
  '/images/مجمع_تجاري_2.png',
  '/images/مجمع_تجاري_7.png',
  '/images/مجمع_تجاري_10.png',
];

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (HERO_IMAGES.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % HERO_IMAGES.length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, []);

  return (
    <div className="home-page-content">
      {/* قسم الهيرو */}
      <motion.div
        className="hero-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="hero-background-image">
          {HERO_IMAGES.map((imagePath, index) => (
            <motion.img
              key={index}
              src={imagePath}
              alt={`Background ${index}`}
              className="hero-bg-img"
              initial={{ opacity: 0 }}
              animate={{ opacity: index === currentIndex ? 1 : 0 }}
              transition={{ duration: 2, ease: 'easeInOut' }}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ))}
          <div className="dark-overlay"></div>
        </div>

        <div className="hero-content">
          <motion.h1
            className="hero-title hero-title-ltr"
            initial="hidden"
            animate="visible"
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.07,
                  delayChildren: 0.5,
                },
              },
            }}
          >
            {"UN-BORDERS".split("").map((char, index) => (
              <motion.span
                key={index}
                className="hero-char"
                variants={{
                  hidden: { opacity: 0, y: 20, scale: 0.8 },
                  visible: { opacity: 1, y: 0, scale: 1 },
                }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                {char}
              </motion.span>
            ))}
          </motion.h1>


          <motion.p
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.3 }}
          >
            حيث يتجاوز التصميم حدود الإمكان
          </motion.p>

          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 1.6 }}
            className="hero-cta-buttons"
          >
            <Link to="/services" className="cta-button">
              اكتشف خدماتنا الهندسية
            </Link>

            {/* زر لوحة متابعة المشاريع بنفس الشكل */}
            <Link  to="/dashboard-guide" className="cta-button secondary-btn">
             لوحة متابعة المشاريع
            </Link>
          </motion.div>
        </div>
      </motion.div>

      {/* ------------------------------------------------------ */}
      {/* قسم النبذة المختصرة */}
      {/* ------------------------------------------------------ */}
      <div className="home-summary-section summary-layout-container">
        <motion.div
          className="summary-text-side"
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2>
            UN-BORDERS
            <br />
            يعني الإبداع بلا حدود
          </h2>
          <p>
            من القاهرة إلى الخليج، فريقنا ملتزم بتقديم حلول تصميم مبتكرة وعملية. نحن نؤمن بأن الهندسة المعمارية يجب أن تكون تجربة تتجاوز مجرد البناء، لتعكس رؤيتك الفريدة وتلبي احتياجات المستقبل.
          </p>
          <Link to="/about" className="cta-button">
            المزيد عن الشركة
          </Link>
        </motion.div>

        <motion.div
          className="summary-image-side"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{  amount: 0.3 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src="/images/design.png"
            alt="UN-BORDERS Project Summary"
          />
        </motion.div>
      </div>

      {/* ------------------------------------------------------ */}
      {/* قسم الخدمات الرئيسي */}
      {/* ------------------------------------------------------ */}
      <div className="home-summary-section summary-layout-container">
        <motion.div
          className="summary-text-side"
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{  amount: 0.3 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2>ما نقدمه من خدمات</h2>
          <p>
            يمتلك فريقنا خبرة واسعة في التصميم المعماري والداخلي، والتخطيط الحضري، والتصميمات الكهربائية والميكانيكية. 
            نسعى لدمج الجمال بالوظيفة في كل مشروع، مع رؤية متكاملة تحقق طموحات عملائنا على أرض الواقع.
          </p>
          <Link to="/services" className="cta-button">
            تصفح كل الخدمات
          </Link>
        </motion.div>

        <motion.div
          className="summary-image-side"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ amount: 0.3 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <img
            src="/images/services-section.png"
            alt="خدمات المكتب الهندسي"
          />
        </motion.div>
      </div>
    </div>
  );
}

export default Home;
